var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "width": "1200px",
      "title": "Ownership Role History",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pb20"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "data": _vm.dataList
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Handling Time",
      "width": "164px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm._f("parseTimeSecond")(scope.row.createAt)) + " ")];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "From"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.from ? _c('p', [_vm._v(_vm._s(scope.row.from.nickname || scope.row.from.username))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "To"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.to ? _c('p', [_vm._v(_vm._s(scope.row.to.nickname || scope.row.to.username))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.ownershipTypeFormat(scope.row.type)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Ownership Role"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.ownershipRoleFormat(scope.row.ownershipRole)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Operator"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.operator.nickname || scope.row.operator.username))])];
      }
    }])
  })], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }